import React, { useState, useEffect } from "react"
import SwitchBox from "../Common/SwitchBox"
import { observer } from "mobx-react"
import FormStore from "../../Configs/Store/forms"
import DOMPurify from "dompurify"

const RecTable = observer(({ table, divider = true }) => {
  const onSwitchBoxToggle = async (e) => {
    var value = Number(e.target.value)
    FormStore.setARR(value)
    // CommonStore.setRecommendedGetPer(value)
    console.log("toggle recfor value", value)
  }

  return (
    <div className="table">
      <div className="PGWrap">
        <div className="pay">
          <span>Pay</span>
          {table.pay} for {table.pay_opt === "Regular" ? table.years : table.ppt} years
        </div>
        {!divider && <hr />}
        <div className="get">
          <span>Get</span>
          <span className="getVal" dangerouslySetInnerHTML={{ __html: FormStore.quote_arr === 8 ? DOMPurify.sanitize(table.get8) : DOMPurify.sanitize(table.get4) }} />
        </div>
      </div>
      {divider && <hr />}
      <div className="Arr">
        <>
          <sup>9</sup>ARR
        </>
        <>
          <SwitchBox onSwitchBoxToggle={onSwitchBoxToggle} type={0} defaultValue={FormStore.quote_arr} value={FormStore.quote_arr} />
        </>
      </div>
    </div>
  )
})

export default RecTable
